module.exports = __webpack_public_path__ + "static/fabric-select-multiple-2d24bec394dc6e681596dceadee88ada.png";